import gql from "graphql-tag.macro";

const loadCurrentInstanceQuery = gql`
    query currentInstance {
        currentInstance {
            ... on Instance {
                _id
            }
        }
    }
`;

export const loadCurrentInstance = async ({ client }) => {
    const {
        data: {
            currentInstance: {
                _id: instanceId,
            },
        },
    } = await client.query({
        query: loadCurrentInstanceQuery,
    });
    return instanceId;
};
